var selectors = {
  linkItem : '[js-parent-link]',
  dropdownItem: '[js-dropdown-item]'
}

const linkItems = document.querySelectorAll(selectors.linkItem);
const dropdownItems = document.querySelectorAll(selectors.dropdownItem);

linkItems.forEach(item => {
  item.addEventListener('mouseover', (e) => {
    e.preventDefault();
    item.classList.add('active');

    const title = item.getAttribute('data-title');

    dropdownItems.forEach(dropdown => {
      const dTitle = dropdown.getAttribute('data-title');

      if (dTitle == title) {
        dropdown.classList.add('active');
      } else {
        dropdown.classList.remove('active');
      }
    });
  });

  item.addEventListener('mouseleave', (e) => {
    e.preventDefault();

    item.classList.remove('active');

    dropdownItems.forEach(dropdown => {
      dropdown.classList.remove('active');
    });
  });
});


dropdownItems.forEach(item => {
  item.addEventListener('mouseover', (e) => {
    e.preventDefault();
    item.classList.add('active');

    const dTitle = item.getAttribute('data-title');

    linkItems.forEach(link => {
      const title = link.getAttribute('data-title');

      if (dTitle == title) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  });

  item.addEventListener('mouseleave', (e) => {
    e.preventDefault();

    item.classList.remove('active');

    linkItems.forEach(link => {
      link.classList.remove('active');
    });
  });
});